import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    searchFacetChange,
    searchFacetClearGroupChange,
} from '../Actions/FacetedSearch.action';

const FilterPills = ({ facetFilters }) => {
    const dispatch = useDispatch();

    const selectedFacetGroup = facetFilters.filter(
        filter => filter.selectedOptions.length > 0,
    );

    const getOrderedOption = (options, position) => {
        const value =
            options?.length > 0
                ? options.map(opt => parseInt(opt)).sort((a, b) => a - b)[
                      position
                  ]
                : [];

        return value;
    };

    return (
        <div className="c-filter__selected__grid">
            <div className="c-filter__selected">
                <div className="c-filter__selected__pills">
                    {selectedFacetGroup &&
                        selectedFacetGroup.map((group, index) => (
                            <div
                                className="c-filter__selected__pills__group"
                                key={`option-${index}`}
                            >
                                <div className="c-filter__selected__pills__group__head">
                                    <button
                                        className="clear-pills"
                                        onClick={event =>
                                            dispatch(
                                                searchFacetClearGroupChange(
                                                    group,
                                                    group.options,
                                                ),
                                            )
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-x-lg"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"></path>
                                        </svg>
                                    </button>
                                    {group.label}
                                </div>
                                {!group.isSlider &&
                                    group.selectedOptions &&
                                    group.selectedOptions.map(
                                        (option, index) => (
                                            <button
                                                className="button"
                                                onClick={event =>
                                                    dispatch(
                                                        searchFacetChange(
                                                            group,
                                                            group.options.filter(
                                                                currentOption =>
                                                                    currentOption.id ===
                                                                    option,
                                                            )[0],
                                                        ),
                                                    )
                                                }
                                                key={`option-${index}`}
                                            >
                                                <span> {option} </span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-x"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </button>
                                        ),
                                    )}
                                {group.isSlider && group.selectedOptions && (
                                    <span>
                                        {getOrderedOption(
                                            group.selectedOptions,
                                            0,
                                        )}{' '}
                                        -{' '}
                                        {getOrderedOption(
                                            group.selectedOptions,
                                            1,
                                        )}
                                    </span>
                                )}
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default FilterPills;
